type TelegramIconProps = {
  height?: number | string;
  width?: number | string;
};

export function TelegramIcon({ height = 16, width = 16 }: TelegramIconProps) {
  return (
    <svg width={width} height={height} viewBox={`0 0 16 16`} fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_14614_56)">
        <path
          d="M14 0H2C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.894205 16 1.99877 16H14.0012C15.1058 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0Z"
          fill="#37AEE2"
        />
        <path
          d="M6.25781 11.9141C5.91406 11.9141 5.94531 11.7891 5.85156 11.4766L4.85156 8.19531L12.5078 3.69531"
          fill="#C8DAEA"
        />
        <path
          d="M6.25781 11.9141C6.47656 11.9141 6.60156 11.7891 6.75781 11.6641L8.16406 10.3203L6.41406 9.25781"
          fill="#A9C9DD"
        />
        <path
          d="M6.4153 9.25648L10.634 12.3502C11.0715 12.6315 11.4465 12.4752 11.5715 11.9127L13.2903 3.85023C13.4465 3.16273 13.009 2.85023 12.5403 3.06898L2.50905 6.94398C1.8528 7.19398 1.8528 7.60023 2.38405 7.75648L4.9778 8.56898L10.9153 4.78773C11.1965 4.63148 11.4465 4.69398 11.259 4.91273"
          fill="#F6FBFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_14614_56">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
